import { LiveViewSwitch } from '@hakimo-ui/hakimo/feature-shared';
import { Modal, Toggle } from '@hakimo-ui/shared/ui-base';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

interface Props {
  id: string;
  name: string;
  imageUrl?: string;
  livestreamUrl?: string;
  open: boolean;
  onClose: () => void;
}

function CameraPreviewModal({
  id,
  name,
  imageUrl,
  livestreamUrl,
  open,
  onClose,
}: Props) {
  const [mode, setMode] = useState<'image' | 'live'>('image');

  return (
    <Modal open={open} onClose={onClose} title={name} closable>
      <div className="w-[640px] p-2">
        <div className="flex justify-end">
          <Toggle
            enabled={mode === 'live'}
            onChange={(val) => setMode(val ? 'live' : 'image')}
            EnabledIcon={EyeIcon}
            DisabledIcon={EyeSlashIcon}
            label="Live View"
            title="Toggle Live View"
          />
        </div>

        <div className="mt-2 aspect-video overflow-hidden rounded-xl bg-black">
          {mode === 'image' && imageUrl && (
            <img
              src={imageUrl}
              alt={name}
              className="h-full w-full object-contain"
            />
          )}

          {mode === 'live' && livestreamUrl && (
            <LiveViewSwitch cameraId={id} livestreamUrl={livestreamUrl} />
          )}
        </div>
      </div>
    </Modal>
  );
}

export default CameraPreviewModal;
